export enum StatusCodes {
    OK = 200,
    CREATED = 201,
    CONTINUE = 202,
    OK_NO_CONTENT = 204,
    NOT_MODIFIED_CLIENT_REDIRECTION_CODE = 304,
    BAD_REQUEST = 400,
    UNAUTHORISED = 401,
    NOT_FOUND = 404,
    FORBIDDEN = 403,
    CONFLICT = 409,
    INTERNAL_SERVER_ERROR = 500
}
